/**
 * FindingsEmptyState -- Shown when an audit has no confirmed findings
 */

import { Plus } from "lucide-react";
import { Button } from "@/components/ui";
import { useTranslation } from "@/packages/utils";

interface FindingsEmptyStateProps {
  onAddFinding: () => void;
}

export function FindingsEmptyState({ onAddFinding }: FindingsEmptyStateProps) {
  const { t } = useTranslation("audits");

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center space-y-3">
      <p className="text-muted-foreground">{t("findings.emptyState.title")}</p>
      <p className="text-sm text-muted-foreground max-w-[320px]">
        {t("findings.emptyState.description")}
      </p>
      <Button variant="accent-soft" size="sm" onClick={onAddFinding}>
        <Plus size={14} className="mr-1" />
        {t("findings.emptyState.cta")}
      </Button>
    </div>
  );
}
